export default {
      id: "logo-cw-usage",
      viewBox: "0 0 175.715 100.743",
      url: "/assets/svg/" + "sprite.svg#logo-cw-usage",
      toString: function () {
        return this.url;
      }
    }